export const DAY_LABEL_WIDTH = 30;
